module.exports = __webpack_public_path__ + "img/rank_9.abd633c.png";